<template>
    <div>
        <div class="obj-item" :class="{'collapse': activeBuildingId != building.id}"
             v-for="building in allBuildings" :key="building.id">
            <div class="item-title" @click="setSelected(building.id)">
                <span :class="{'main-color': needSelect(building.id)}">{{building.title}}</span>
                <img class="arrow" src="/images/svg/up-arrow.svg" alt="">
            </div>

            <div class="item-sub-items">
                <template v-if="selectedBuilding">
                    <div v-if="selectedBuilding.device_ids.length"
                         v-for="devId in selectedBuilding.device_ids">
                        <device-item :dev-id="devId" :key="devId"></device-item>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>


<script>
    import {mapActions} from 'vuex'
    import DeviceItem from './device'
    import { BUILDING_SET_SELECTED } from '../../store/muations'
    import _ from 'lodash'

    export default {
        components: {
            DeviceItem,
        },

        data() {
            return {
                // expandId: 0,
            };
        },

        mounted(){
            console.log(this.$route)
        },

        methods: {
            setSelected(bId){
                if(this.activeBuildingId != bId){
                    this.$store.commit(BUILDING_SET_SELECTED, bId)
                    this.$router.push({name: "building-selected", params: {buildingId: bId} });
                } else {
                    this.$store.commit(BUILDING_SET_SELECTED, 0)
                    this.$router.push({name: "building" });
                }
            },
            toAddDevPage(id){
                this.$router.push({name: "device-add", params: {buildingId: id} });
                setTimeout(()=>{
                    this.hideLeftMenu();
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    });
                }, 100)
            },
            ...mapActions([
                'hideLeftMenu',
            ]),
            needSelect(bId){
                return this.$route.params.buildingId == bId && this.$route.name === 'device-add';
            }
        },

        computed: {
            allBuildings() {
                return _.sortBy(this.$store.state.buildings.all, 'title');
            },
            activeBuildingId(){
                return this.$route.params.buildingId;
            },
            selectedBuilding(){
                return this.$store.state.buildings.all[this.$route.params.buildingId]
            },
        },

    }
</script>
